export default function KitchenHero() {
  return (
    <section className="relative w-full min-h-[90vh] overflow-hidden flex items-center pt-48 md:pt-52 pb-28">
      <img
        src="/images/kitchen/extraction-hood.webp"
        alt="Commercial Kitchen Fabrication"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/55 to-black/30"></div>

      {/* Floating badge */}
      <div className="absolute top-32 md:top-36 left-6 md:left-16 z-10 bg-teal-600 text-white text-xs font-bold px-4 py-1.5 rounded-full uppercase tracking-widest">
        Kenya&apos;s #1 Kitchen Fabricators
      </div>

      <div className="relative z-10 w-full">
        <div className="w-full max-w-7xl mx-auto px-6 md:px-16">
          <span className="text-teal-400 text-xs font-semibold uppercase tracking-widest mb-4 block">
            ISMAN Engineering — Commercial Division
          </span>
          <h1 className="text-white text-3xl sm:text-4xl md:text-5xl xl:text-6xl font-extrabold leading-tight uppercase tracking-tight max-w-3xl mb-6">
            Commercial Kitchen<br />
            <span className="text-teal-400">Fabrication &amp;</span><br />
            Installation
          </h1>
          <p className="text-white/75 text-sm md:text-base leading-relaxed max-w-xl mb-10">
            From restaurants and hotels to hospitals and schools — we design, fabricate, and install precision-grade stainless steel commercial kitchen systems built for the demands of professional cooking.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="#inquiry"
              onClick={(e) => { e.preventDefault(); document.querySelector("#inquiry")?.scrollIntoView({ behavior: "smooth" }); }}
              className="bg-teal-600 hover:bg-teal-500 text-white font-bold px-8 py-3 rounded-md uppercase text-sm tracking-wider transition-colors cursor-pointer whitespace-nowrap text-center"
            >
              Get a Free Quote
            </a>
            <a
              href="#offerings"
              onClick={(e) => { e.preventDefault(); document.querySelector("#offerings")?.scrollIntoView({ behavior: "smooth" }); }}
              className="border border-white/40 hover:border-teal-400 hover:text-teal-400 text-white font-bold px-8 py-3 rounded-md uppercase text-sm tracking-wider transition-colors cursor-pointer whitespace-nowrap text-center"
            >
              Explore Our Work
            </a>
          </div>

          {/* Quick stats */}
          <div className="flex flex-wrap gap-8 mt-14">
            {[
              { value: "500+", label: "Kitchens Installed" },
              { value: "15+", label: "Years Experience" },
              { value: "100%", label: "Food-Grade Steel" },
              { value: "48hr", label: "Response Time" },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <p className="text-teal-400 text-2xl font-extrabold">{stat.value}</p>
                <p className="text-white/60 text-xs uppercase tracking-wider mt-0.5">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll cue */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 opacity-70">
        <span className="text-white text-xs tracking-widest uppercase">Scroll</span>
        <div className="w-px h-12 bg-gradient-to-b from-white/50 to-transparent"></div>
      </div>
    </section>
  );
}
